import { UserProfile } from '@oy/types';
import { AuthOtp } from 'src/models/Auth';
import { LoginData } from 'src/models/Login';

export const setAuth = (payload: any) => ({
  type: 'SET_AUTH',
  payload,
});

export const setAuthDataStaging = (payload: LoginData) => ({
  type: 'SET_AUTH_DATA_STAGING',
  payload,
});

export const clearAuth = () => ({
  type: 'CLEAR_AUTH',
});

export const setAuthOtp = (payload: AuthOtp) => ({
  type: 'SET_AUTH_OTP',
  payload,
});

export const clearAuthOtp = () => ({
  type: 'CLEAR_AUTH_OTP',
});

export const setAuthUser = (payload: UserProfile | null) => ({
  type: 'SET_AUTH_USER',
  payload,
});

export const setDefaultUser = () => ({
  type: 'SET_DEFAULT_USER',
});

export const setShowOtpModal = (payload: boolean) => ({
  type: 'SET_SHOW_OTP_MODAL',
  payload,
});
